import { onMounted, onUnmounted } from 'vue'

export function useEscapeKey(callback: () => void) {
  let overlayWasActive = false

  // Capture phase fires before any Vuetify handler can mutate state.
  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      overlayWasActive = !!document.querySelector('.v-overlay--active')
    }
  }

  const onKeyUp = (event: KeyboardEvent) => {
    if (event.key !== 'Escape') return
    if (overlayWasActive) {
      overlayWasActive = false
      return
    }
    callback()
  }

  onMounted(() => {
    window.addEventListener('keydown', onKeyDown, true)
    window.addEventListener('keyup', onKeyUp)
  })

  onUnmounted(() => {
    window.removeEventListener('keydown', onKeyDown, true)
    window.removeEventListener('keyup', onKeyUp)
  })
}
